import React, { useContext } from 'react'
import { Controller } from 'react-hook-form'
import FormContext from '../../context/formContext'
import '../Input/index.scss'
import './index.scss'

/**
 * @desc Custom Select. Handles: 
 *  - select props 
 *  - label props 
 *  - error props 
 *  - ignore error
 *  - controlled boolean
 *  - pulls control from Form context
 */
export const Select = ({ 
  selectProps = {}, labelProps = {}, errorProps = {}, 
  fieldName, ignoreError = false, controlled = true,
  options = []
}) => {

  // CONSTANTS ----------------------------------------------------------------

  const { control = {} } = useContext(FormContext)
  const defaultValue = options?.[0]?.value

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Render error line.
   */
  const renderError = ({ invalid, error }) => {
    if (!invalid || ignoreError) return
    const errorIconProps = {
      src: "https://funko.com/on/demandware.static/Sites-FunkoUS-Site/-/default/dwe062a1ec/images/svg/error.svg",
      className: "svg-symbol error error-icon"
    }
    return (
      <div className="invalid-feedback" {...errorProps}>
        <img alt={'error-icon'} {...errorIconProps} />
        <span role="alert">{error.message}</span>    
      </div>
    )
  }

  /**
   * @desc Render form label
   */
  const renderLabel = () => {
    if (!labelProps || !labelProps.children) return null
    return (<label className={'form-control-label'} {...labelProps} />)
  }

  // COMPONENT ----------------------------------------------------------------

  if (!controlled) {
    const selectUncontrolledProps = {
      ...selectProps,
      defaultValue,
      className: `custom-select ${selectProps.className}`
    }
    const uncontrolledOptionEls = options.map(({ label, value }, index) => (
      <option key={`option-${index}`} value={value}>{label}</option>
    ))
    return (
      <div className={`form-group ${selectProps.required ? 'required' : ''}`}>
        {renderLabel()}
        <select {...selectUncontrolledProps}>
          {uncontrolledOptionEls}
        </select>
      </div>
    )
  }

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({field: { onChange, onBlur, value }, fieldState }) => {
        const invalid = fieldState.invalid 
        const selectControllerProps = {
          ...selectProps,
          onChange,
          onBlur,
          value: value || '',
          className: `custom-select ${selectProps.className} ${invalid && !ignoreError ? 'is-invalid' : ''}`
        }
        const optionEls = options.map((option, index) => (
          <option key={`option-${index}`} value={option.value}>
            {option.label}
          </option>
        ))

        return (
          <div className={`form-group ${selectProps.required ? 'required' : ''}`}>
            {renderLabel()}
            <select {...selectControllerProps}>
              {optionEls}
            </select>
            {renderError(fieldState)}
          </div>
        )
      }}
    />
  )
}
